export type TimeOptions = {
  time: string;
};

const generateTimeOptions = (startTimeProp?: string, endTimeProp?: string): Array<TimeOptions> => {
  const startTime: string = !startTimeProp ? '00:00' : startTimeProp;
  const endTime: string = !endTimeProp ? '23:59' : endTimeProp;

  const options: Array<TimeOptions> = [];
  let d = new Date(`January 1 2017 ${startTime}`);
  const dEnd = new Date(`January 1 2017 ${endTime}`);

  options.push({ time: createDateString(d) });

  while (d.getTime() < dEnd.getTime()) {
    d = addMinutes(d, 30);
    if ((d.getMinutes() < 15 || d.getMinutes() > 44) && d.getMinutes() !== 0) {
      d.setMinutes(0);
    }

    if (d.getMinutes() > 14 && d.getMinutes() < 45 && d.getMinutes() !== 30) {
      d.setMinutes(30);
    }

    options.push({ time: createDateString(d) });
  }
  return options;
};

const addMinutes = (date: Date, minutes: number): Date => {
  return new Date(date.getTime() + minutes * 60000);
};

const createDateString = (date: Date): string => {
  const hours = date.getHours();
  const minutes = date.getMinutes();

  const finalHours: string = hours < 10 ? `0${hours.toString()}` : hours.toString();
  const finalMinutes: string = minutes < 10 ? `0${minutes.toString()}` : minutes.toString();

  return `${finalHours}:${finalMinutes}`;
};

export default generateTimeOptions;
